import React, {useState} from "react";
import Chart from "react-apexcharts";

const TotalRevenue = () => {

    const chartOptions = {
        chart: {
          id: 'total-revenue',
          toolbar: {
            show: false, // Hide toolbar if unnecessary
          },
        },
        colors: ['#1E90FF', '#32CD32'], // Blue for 'Profit' and Green for 'Loss'
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: '50%', // Adjust the width of bars
            endingShape: 'rounded', // Gives rounded corners to the bars
          },
        },
        dataLabels: {
          enabled: false, // Disable data labels on top of bars
        },
        xaxis: {
          categories: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
          title: {
            text: '',
          },
        },
        yaxis: {
          title: {
            text: '',
          },
          min: 0,
          max: 25000, // Set the maximum value on the y-axis
          tickAmount: 5,
        },
        legend: {
          position: 'bottom',
          markers: {
            fillColors: ['#1E90FF', '#32CD32'], // Colors in the legend
          },
        },
        grid: {
          strokeDashArray: 3, // Gridline styling
        },
      };
    
      const chartSeries = [
        {
          name: 'Basavraj P',
          data: [12000, 15000, 2000, 18000, 10000, 15000, 20000],
        },
        {
          name: 'Manjunath D',
          data: [8000, 10000, 20000, 5000, 6000, 8000, 10000],
        },
      ];
    
      return (
        <div>
          <Chart options={chartOptions} series={chartSeries} type="bar" height="220" />
        </div>
      );
}

export default TotalRevenue;